import urls from "global/constants/UrlConstants";
import { WorkspaceApiResponse, WorkspaceRole } from "types/workspace";
import { getCallParams, makeCall } from "utils/service";

export const fetchWorkspaceRoles = async (): Promise<WorkspaceRole[]> => {
  try {
    const callParams = await getCallParams("GET");
    const response: WorkspaceRole[] = await makeCall(
      urls.WORKSPACE_ROLE_FETCH,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const createWorkspaceRole = async (
  name: string,
  permissions: string[],
): Promise<WorkspaceApiResponse> => {
  try {
    const callParams = await getCallParams("POST", {
      name,
      permissionsJson: JSON.stringify(permissions),
    });
    const response: WorkspaceApiResponse = await makeCall(
      urls.WORKSPACE_ROLE_ADD,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateWorkspaceRole = async (
  id: number,
  name: string,
  permissions: string[],
): Promise<WorkspaceApiResponse> => {
  try {
    const callParams = await getCallParams("PUT", {
      name,
      permissionsJson: JSON.stringify(permissions),
    });
    const response: WorkspaceApiResponse = await makeCall(
      `${urls.WORKSPACE_ROLE_UPDATE}/${id}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

/** reassignTo is only needed when the role is assigned to members (backend answers 409 otherwise). */
export const deleteWorkspaceRole = async (
  id: number,
  reassignTo?: number,
): Promise<WorkspaceApiResponse> => {
  const url =
    reassignTo != null
      ? `${urls.WORKSPACE_ROLE_DELETE}/${id}?reassignTo=${reassignTo}`
      : `${urls.WORKSPACE_ROLE_DELETE}/${id}`;
  try {
    const callParams = await getCallParams("DELETE");
    const response: WorkspaceApiResponse = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const assignWorkspaceRole = async (
  membershipId: string,
  roleId: number,
): Promise<WorkspaceApiResponse> => {
  try {
    const callParams = await getCallParams("POST");
    const response: WorkspaceApiResponse = await makeCall(
      `${urls.WORKSPACE_MEMBERSHIP}/${membershipId}/role/${roleId}`,
      callParams,
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};
